import React from "react";
import { CheckCircle2, XCircle, Loader2, Info } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function PayBanner() {
  const { payBanner, setPayBanner } = useApp();
  if (!payBanner) return null;

  const map = {
    processing: { icon: <Loader2 size={16} className="animate-spin" />, cls: "bg-[#1a1430] border-[#8b5cf6]/40 text-white" },
    success: { icon: <CheckCircle2 size={16} className="text-emerald-400" />, cls: "bg-emerald-500/10 border-emerald-500/30 text-emerald-100" },
    error: { icon: <XCircle size={16} className="text-red-400" />, cls: "bg-red-500/10 border-red-500/30 text-red-100" },
    cancel: { icon: <Info size={16} className="text-white/70" />, cls: "bg-white/10 border-white/20 text-white" },
  };
  const cfg = map[payBanner.state] || map.processing;

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-[90] w-[92%] max-w-[440px]">
      <div className={`flex items-center gap-2.5 px-4 py-3 rounded-xl border backdrop-blur-xl shadow-xl ${cfg.cls}`}>
        {cfg.icon}
        <span className="text-[13px] flex-1">{payBanner.msg}</span>
        {payBanner.state !== "processing" && (
          <button onClick={() => setPayBanner(null)} className="text-[12px] opacity-60 hover:opacity-100">Dismiss</button>
        )}
      </div>
    </div>
  );
}
